import { useState, useCallback } from 'react';
function serialize(value) {
    return typeof value === 'string' ? value : JSON.stringify(value);
}
/**
 * Try to parse LocalStorage value otherwise return value
 * e.g. localStorage values
 * "123" (stringified Number) => 123 (number)
 * "false" (stringified Boolean) => false (boolean)
 * ey73n3ngj3udnfm (non-stringified string)=> ey73n3ngj3udnfm
 */
function deserialize(value) {
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return value;
    }
}
export function useStorage(getStorageBackend, key, initialValue, onError) {
    const [, setCounter] = useState(0);
    let backend = null;
    let item = null;
    try {
        backend = getStorageBackend();
        item = backend.getItem(key);
    }
    catch (error) {
        if (onError) {
            onError(error);
        }
        // Storage backend is not available, fall back to initial value
        item = initialValue;
    }
    const rerender = useCallback(() => {
        setCounter(counter => counter + 1);
    }, []);
    const setItem = useCallback(value => {
        const serializedValue = serialize(value);
        if (value !== null && value !== undefined) {
            if (serializedValue !== item) {
                if (backend !== null) {
                    try {
                        backend.setItem(key, serializedValue);
                    }
                    catch (error) {
                        if (onError) {
                            onError(error);
                        }
                    }
                }
                rerender();
            }
        }
        else {
            if (backend !== null) {
                try {
                    backend.removeItem(key);
                }
                catch (error) {
                    if (onError) {
                        onError(error);
                    }
                }
            }
            rerender();
        }
    }, [item, key, onError, rerender, backend]);
    // Make sure we don't throw an error when the storage backend is not available
    if (initialValue !== null && initialValue !== undefined && item === null) {
        try {
            setItem(initialValue);
        }
        catch (error) {
            if (onError) {
                onError(error);
            }
        }
    }
    return [deserialize(item), setItem];
}
